module.exports = __webpack_public_path__ + "static/media/vanasthali.7fabb534.png";